import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import KitPreferenceIcon from '../../../assets/icons/KitPreferenceIcon';

const ProcedureEquipmentListsList = (props) => {
  const {
    equipmentLists = [],
    onClick,
    onReorder,
    tenantColor,
    selectedEquipmentList,
  } = props;

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const newItems = Array.from(equipmentLists);
    const [removed] = newItems.splice(result.source.index, 1);
    newItems.splice(result.destination.index, 0, removed);

    if (onReorder) onReorder(newItems);
  };

  return (
    <div className='flows-list__container'>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId='equipmentLists'>
          {(provided) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              <div
                className='flow-list__item'
                onClick={() => onClick(null)}
              >
                <KitPreferenceIcon />
                <span>Equipment Options</span>
              </div>

              {equipmentLists.map((equipmentList, index) => (
                <Draggable
                  key={equipmentList.id}
                  draggableId={equipmentList.id}
                  index={index}
                >
                  {(provided) => (
                    <div
                      className={`procedure-equipment-list__item${equipmentList.id === selectedEquipmentList?.id ? ' selected' : ''}`}
                      onClick={() => onClick(equipmentList)}
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                    >
                      <div className='d-flex'>
                        <div {...provided.dragHandleProps} style={{ display: 'flex', alignItems: 'center' }}>
                          <KitPreferenceIcon
                            color={
                              equipmentList.id === selectedEquipmentList?.id
                                ? tenantColor
                                : '#000000'
                            }
                          />
                        </div>
                        <span
                          style={{
                            color:
                              equipmentList.id === selectedEquipmentList?.id
                                ? tenantColor
                                : '#000000',
                          }}
                        >
                        {equipmentList.name}
                      </span>
                      </div>
                      <div className='p-sm d-flex flex-center' {...provided.dragHandleProps}>
                        <DragIndicatorIcon />
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};

export default ProcedureEquipmentListsList;
